// Common file type extensions for file uploads

export const FileTypeConstants = {
  // Image formats
  IMAGES: ['.jpeg', '.jpg', '.png', '.webp', '.heic', '.heif'],

  // Document formats
  DOCUMENTS: ['.pdf', '.docx', '.xlsx', '.xls'],

  // Combined: Images and documents (most common use case)
  IMAGES_AND_DOCUMENTS: ['.jpeg', '.jpg', '.png', '.webp', '.heic', '.heif', '.pdf', '.docx'],

  // Payment proof files
  PAYMENT_PROOF: ['.pdf', '.png', '.jpg', '.jpeg', '.webp', '.heic', '.heif'],

  // File types that cannot be previewed in browser and should auto-download
  // Note: HEIC files uploaded before HEIC support was added are stored as .heic
  // Browsers can't display HEIC natively, so auto-download them
  AUTO_DOWNLOAD: ['.docx', '.xlsx', '.xls', '.heic', '.heif', '.odt'],

  // All supported formats
  ALL_SUPPORTED: ['.jpeg', '.jpg', '.png', '.webp', '.heic', '.heif', '.pdf', '.docx', '.xlsx', '.xls' , '.odt'],
};

// Helper function to get a custom combination
export const getFileTypes = (...types: (keyof typeof FileTypeConstants)[]): string[] => {
  const combined = new Set<string>();
  types.forEach(type => {
    FileTypeConstants[type].forEach(ext => combined.add(ext));
  });
  return Array.from(combined);
};
